import FieldTypesEnum from "../Enums/FieldTypesEnum";
import React from 'react';
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";

export default class LookupAdminItem 
{
    constructor (item) 
    {
        if (item === undefined) 
        {
            this.LookupItemId = "";
            this.LookupId = "";
            this.Text = "";
            this.Value = "";
            this.IsActive = "";
            this.Order = "";
            this.Misc = "";
            return;
        }
        this.LookupItemId = item.lookupItemId;
        this.LookupId = item.lookupId;
        this.Text = item.text;
        this.Value = item.value;
        this.IsActive = item.isActive;
        this.Order = item.order;
        this.Misc = item.misc;

    }

    static NameOfTheIdField () { return "Text"; }

    static nameOfTheItemDetailList () { return "Lookups"; }

    static MoneyFields = [];

    static Currency () { return ""; };

    static MoneyFieldsSecondary = [];

    static CurrencySecondary () { return ""; };

    static DateFields = [];

    static BoolFields = [];

    static FieldsToShowInListTable = [];

    static FieldsToShowInDataTable ()  
    {
        return [
            { label: "Id", orderById: "Id", data: "LookupItemId", minWidth: 80 },
            { label: "Text", orderById: "Text", data: "Text" },
            { label: "Value", orderById: "Value", data: "Value" },
            { label: "Misc", orderById: "Misc", data: "Misc" },
            { label: "Order", orderById: "Order", data: "Order" },
            { label: "Active", orderById: "IsActive", data: LookupAdminItem.isActive },
            { label: " ", orderByid: "", data: LookupAdminItem.getActionsContent, type: FieldTypesEnum.ActionButton, rolekey: "LookupAdminItemUpdate", className: "text-center" }
        ];
    }

    static getActionsContent (item)
    {
        return (
            <DataTableActionMenu
                options={[
                    {
                        text: "Edit",
                        onClick: () => LookupAdminItem.EditLookupAdminItemFunction(item.LookupItemId, item),
                        iconName: "fa-solid fa-edit"
                    }
                ]}
            />
        );
    }

    static EditLookupAdminItemFunction = (id, item, itemList) => 
    {
        alert("Empty function");
    };

    static isActive (item) 
    {
        if (item.IsActive !== undefined && (item.IsActive === true || item.IsActive === "true" || item.IsActive === "True"))
            return "Yes";

        return "No";
    }
}
